var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 1.33333C11.6769 1.33333 14.6663 4.3228 14.6663 7.99999C14.6663 11.6772 11.6769 14.6667 7.99967 14.6667C4.32248 14.6667 1.33301 11.6772 1.33301 7.99999C1.33301 4.3228 4.32248 1.33333 7.99967 1.33333ZM7.44438 3.92982H8.54095C9.09356 3.92982 9.51689 4.42118 9.43513 4.9677L8.88685 8.63313C8.82062 9.07588 8.44035 9.4035 7.99267 9.4035C7.54499 9.4035 7.16472 9.07588 7.09849 8.63313L6.5502 4.9677C6.46845 4.42118 6.89178 3.92982 7.44438 3.92982ZM7.99967 10.2456C8.50493 10.2456 8.91196 10.6526 8.91196 11.1579C8.91196 11.6631 8.50493 12.0702 7.99967 12.0702C7.49442 12.0702 7.08739 11.6631 7.08739 11.1579C7.08739 10.6667 7.49442 10.2456 7.99967 10.2456Z",
    fill: "#C83532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.736eeaac.svg";
export { ForwardRef as ReactComponent };